import React from 'react';
import PropTypes from 'prop-types';

import Config from '@/config';

const EmbedCode = ({ bga_quoter }) => {
  return (
    <div>
      <p style={{ fontFamily: 'monospace', lineHeight: '1.8em', fontSize: '12px' }}>
        {`<link href='${Config.ALQ_URL}@css/reset.css' rel='stylesheet' type='text/css'>`}
        <br />
        {"<script type='text/javascript'>"}
        <br />
        <span
          style={{ marginLeft: '20px' }}
        >{`window.IXN_QUOTER_CONFIG = { id: '${bga_quoter.token}' };`}</span>
        <br />
        {'</script>'}
        <br />
        {"<div id='ixn-agency-quoter'></div>"}
        <br />
        {`<script type='text/javascript' src='${Config.ALQ_URL}js/alq.widget.js'></script>`}
      </p>
    </div>
  );
};

EmbedCode.propTypes = {
  bga_quoter: PropTypes.object
};

export default EmbedCode;
